import { cn } from './cn'

/**
 * 会眨眼的 logo。
 *
 * 深绿圆角方块，下缘更圆所以看着像个头；里面两条浅色竖条是眼睛，
 * 一只跑 npcblink（眨眼）另一只跑 npcwink（挑眉），周期都是 4 秒但波形不同，
 * 所以看起来不是"同步眨"而是有点表情。右上角那个亮绿圆点表示"醒着"。
 *
 * 尺寸只有两档：侧边栏 27px、登录页 32px。别的地方不要用别的尺寸。
 */
export interface LogoProps {
  size?: 'sidebar' | 'auth'
  className?: string
}

const eye =
  'h-[var(--container-npc-logo-eye-h)] w-[var(--container-npc-logo-eye-w)] ' +
  'rounded-npc-eye bg-npc-logo-eye'

export function Logo({ size = 'sidebar', className }: LogoProps) {
  const box = size === 'auth' ? 'size-[var(--container-npc-logo-auth)]' : 'size-[var(--container-npc-logo-sidebar)]'

  return (
    <div
      aria-hidden="true"
      className={cn(
        'relative flex shrink-0 items-center justify-center bg-npc-green',
        'gap-[var(--container-npc-logo-eye-gap)]',
        'rounded-[var(--radius-npc-logo)]',
        box,
        className,
      )}
    >
      <span className={cn(eye, 'animate-npc-blink')} />
      <span className={cn(eye, 'animate-npc-wink')} />
      <span className="absolute -right-[2px] -top-[2px] size-[var(--container-npc-status-dot)] rounded-npc-full border-2 border-npc-dark bg-npc-green-bright" />
    </div>
  )
}
